/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Content from './Content/index'
import PaymentProvider from 'DesignSystem/PaymentProvider/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content"
  
}) {
let globalCurrentLocationXidValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.xid',
})
  return (<React.Fragment
>
<PaymentProvider
  viewPath={`${viewPath}/PaymentProvider`}
 allowLocationChoice={true}
 data="global.current_location.xid"
 xid={globalCurrentLocationXidValueData}
 viewPath={viewPath}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PaymentProvider>
{children}
</React.Fragment>)
}